import { Injectable } from '@angular/core';
import querystring from 'query-string';
import { HttpClient } from '@angular/common/http';
import { IToken } from '../interfaces/token.interface';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';

@Injectable()
export class AuthService {
  private http: HttpClient;

  private headers: object = {
    'Accept': 'application/json',
    'Content-Type': 'text/plain;charset=UTF-8'
  };
  private headers2: object = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };
  notifyOptions: any = {
    'width': 'auto',
    'minWidth': '350px',
    'displayTime': 6000,
    'contentTemplate': 'content'};

  constructor(http: HttpClient, private router: Router) {
    this.http = http;
  }

  public signIn(username, password): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.api}/token`, querystring.stringify({
        'grant_type': 'password',
        'username': username,
        'password': password
      }), { ...this.headers })
        .toPromise()
        .then((token: IToken) => {
          this.setToken(token);
          return resolve();
        })
        .catch(error => {
          return reject(error);
        });
    });
  }

  public signOut(): Promise<any> {
    return new Promise((resolve) => {
      this.http.post(`${environment.api}/api/user/logout`, {}, { headers: {
        ...this.headers2,
        Authorization: `Bearer ${this.getToken()}`
      }})
        .toPromise()
        .then(() => {
          this.removeToken();
          return resolve();
        })
        .catch(error => {
          this.removeToken();
          return resolve();
        });
    });
  }

  private setToken(token: IToken) {
    localStorage.setItem('token', token['access_token']);
    localStorage.setItem('tokenExpire', token['.expires']);
    localStorage.setItem('userName', token['userName']);
    localStorage.setItem('userID', token['userID']);
    localStorage.setItem('webuserID', token['webuserID']);
  }

  public getToken() {
    const token = localStorage.getItem('token');
    const expire = localStorage.getItem('tokenExpire');
    if (!token && !expire) {
      return null;
    }

    const now = new Date().getTime();
    const exp = new Date(expire).getTime();

    if (now >= exp) {
      this.removeToken();
      return null;
    }

    console.log('token', localStorage.getItem('token'));
    return localStorage.getItem('token');
  }

  public removeToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpire');
    localStorage.removeItem('userName');
    localStorage.removeItem('userID');
    localStorage.removeItem('webuserID');
  }

  public checkLoginFromResponse(response: any) {
    if ( response.isLoggedIn === 0) {
      this.notifyOptions.message = 'Youv\'e been logged out, please re-login';
      notify(this.notifyOptions, 'info');

      this.router.navigate(['/']);
      return;
    }
  }
}
